var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.23 52.25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u56FE\\u5C42 1",
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.61 1.17l-2 1.23A43 43 0 011 8.45v22.39a14.84 14.84 0 007 12.9l12.6 7.36 12.61-7.36a14.84 14.84 0 007-12.9V8.45a42.9 42.9 0 01-17.58-6z",
    stroke: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00b468",
    d: "M31.67 18.96L18.8 31.82l-7.31-7.32"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MS4yMyA1Mi4yNSI+PGRlZnM+PHN0eWxlPi5jbHMtMSwuY2xzLTJ7ZmlsbDpub25lO3N0cm9rZS13aWR0aDoycHg7fS5jbHMtMXtzdHJva2U6IzI0MjQyNDt9LmNscy0ye3N0cm9rZTojMDBiNDY4O308L3N0eWxlPjwvZGVmcz48ZyBpZD0i5Zu+5bGCXzIiIGRhdGEtbmFtZT0i5Zu+5bGCIDIiPjxnIGlkPSLlm77lsYJfMS0yIiBkYXRhLW5hbWU9IuWbvuWxgiAxIj48cGF0aCBpZD0iUGF0aCIgY2xhc3M9ImNscy0xIiBkPSJNMjAuNjEsMS4xN2wtMiwxLjIzQTQzLDQzLDAsMCwxLDEsOC40NVYzMC44NGExNC44NCwxNC44NCwwLDAsMCw3LDEyLjlsMTIuNiw3LjM2LDEyLjYxLTcuMzZhMTQuODQsMTQuODQsMCwwLDAsNy0xMi45VjguNDVhNDIuOSw0Mi45LDAsMCwxLTE3LjU4LTZaIi8+PHBvbHlsaW5lIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIzMS42NyAxOC45NiAxOC44IDMxLjgyIDExLjQ5IDI0LjUiLz48L2c+PC9nPjwvc3ZnPg==";
export { SvgSecurity as ReactComponent };